import { render, staticRenderFns } from "./TagLabel.vue?vue&type=template&id=3cce006b&scoped=true"
import script from "./TagLabel.vue?vue&type=script&lang=ts"
export * from "./TagLabel.vue?vue&type=script&lang=ts"
import style0 from "./TagLabel.vue?vue&type=style&index=0&id=3cce006b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cce006b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cce006b')) {
      api.createRecord('3cce006b', component.options)
    } else {
      api.reload('3cce006b', component.options)
    }
    module.hot.accept("./TagLabel.vue?vue&type=template&id=3cce006b&scoped=true", function () {
      api.rerender('3cce006b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/Tags/TagLabel.vue"
export default component.exports